module.exports = __webpack_public_path__ + "img/marker-outline.9f107971.svg";